// src/components/Header.js
import React from "react";
import { Link } from "react-router-dom";
import styles from "../styles/Header.module.css";
import logo from "../assets/app_logo.jpg"; // 로고 이미지 경로

function Header() {
  return (
    <header className={styles.header}>
      <div className={styles.leftSection}>
        <Link to="/" className={styles.logoLink}>
          <img src={logo} alt="회사 로고" className={styles.logo} />
          <span className={styles.companyName}>이룸그린테크</span>
        </Link>
      </div>
      <nav className={styles.rightSection}>
        <Link to="/" className={styles.navLink}>
          회사 소개
        </Link>
        <Link to="/ecopick" className={styles.navLink}>
          이코픽
        </Link>
        <Link to="/dream" className={styles.navLink}>
          들어드림
        </Link>
        <Link to="/contact" className={styles.navLink}>
          Contact
        </Link>
      </nav>
    </header>
  );
}

export default Header;
